
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useBuyer } from "@/contexts/BuyerContext";

const NotFound = () => {
  const location = useLocation();
  const { user } = useAuth();
  const { isBuyer } = useBuyer();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  // Determine the appropriate dashboard link based on user type
  const dashboardLink = user ? (isBuyer ? "/buyer/dashboard" : "/seller/dashboard") : "/";

  return (
    <div className="min-h-screen flex items-center justify-center bg-godyspo-background">
      <div className="text-center space-y-6 animate-fade-in p-6">
        <h1 className="text-6xl font-bold text-godyspo-gold">404</h1>
        <h2 className="text-2xl font-medium">Page Not Found</h2>
        <p className="text-muted-foreground max-w-md mx-auto">
          The page you are looking for doesn't exist or has been moved to another location.
        </p>
        <Button asChild className="bg-godyspo-gold hover:bg-godyspo-gold/90 text-black">
          <Link to={dashboardLink}>
            <Home className="mr-2 h-4 w-4" />
            Return to Dashboard
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
